import Header from "../../components/Header"
import * as S from "./style";

const Job = () => (
  <>
    <Header />
  </>
);

export default Job;
